<!--ptw总包与分包分类-->
<template>
  <div style="width: 100%; height: 100%; position: absolute">
    <h1
      style="width: 100%; height: 70px; position: absolute; color: white; font-weight: bold; font-size: 42px; line-height: 70px; padding-left: 20px; text-align: left">
      Daily Summary
    </h1>
    <div v-if="dataNotNull" key="1" class="dailydiv"
         style="width: 100%; height: 100%; position: absolute; bottom: 0">
      <div style="height: 100%; margin-top: 15%;color: #66CCFF;text-align: left;margin-left: 10%">
        <div style="margin-top: 10px">Date:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ date|dateformaten }}
        </div>
        <div style="margin-top: 20px">On-site:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ onsiste }}</div>
        <div style="margin-top: 20px">Swab Test:&nbsp;{{ swab }}</div>
        <div style="margin-top: 20px">
          Out:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ out }}
        </div>
      </div>
    </div>
    <div v-else key="2"
         style="width: 100%; height: 793px; position: absolute; bottom: 0; line-height: 793px; color: #6CF; font-size: 64px;">
      No Data !
    </div>
  </div>
</template>

<script>
import echarts from 'echarts'
import axios from 'axios'

export default {
  props: ['project_id'],
  name: "ptwclassifys",
  data() {
    return {
      color: this.$store.state.color.chart_color,
      myChart: {},
      name: "dailystatics",
      dataNotNull: true,
      date: "",
      onsiste: 0,
      swab: 0,
      out: 0
    }
  },
  methods: {
    init() {
      // this.$root.charts.push(this.myChart)
      window.addEventListener("resize", function () {
        this.myChart.resize()
      }.bind(this))
    },
    formatWidth(str, width) {
      str += ''
      if (str.length < width)
        return this.formatWidth('0' + str, width)
      else
        return str
    },
    pad(num, n) {
      return Array(n > num ? (n - ('' + num).length + 1) : 0).join(0) + num;
    },
    getNowFormatDate() {
      var date = new Date();
      var seperator1 = "-";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 0 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var currentdate = year + seperator1 + month + seperator1 + strDate;
      return currentdate;
    },
  },
  mounted() {
    let that = this
    that.date = this.getNowFormatDate()
    let postData = {
      proj_id: this.project_id,
      bes_project_id: window.localStorage.getItem('bes_project_id'),
      user: window.localStorage.getItem("token_key"),
      token: window.localStorage.getItem('token'),
      startdate: that.date,
      enddate: that.date
    }
    axios.post(this.$store.getters.getHCSServer + "IOsummary", postData).then(resp => {
      var errNo = resp.data.errno
      var errStr = resp.data.errstr_cn
      if (errNo == "0") {
        this.dataNotNull = true
        var result = resp.data.result;
        for (var i in result) {
          if (result[i].direction.toUpperCase() == 'IN') {
            that.onsiste = result[i].count
          } else if (result[i].direction.toUpperCase() == 'OUT') {
            that.out = result[i].count
          } else {
            that.swab = result[i].count
          }
        }
      } else {
        this.dataNotNull = false
      }
    }).catch(error => {
      alert(error)
      this.dataNotNull = false
    })
  },
  filters: {
    dateformaten: function (value) {
      if (!value) return ''
      value = value.toString()
      let day = value.split('-')[2]
      let month = value.split('-')[1]
      let year = value.split('-')[0]
      return day + '/' + month + '/' + year
    }
  }
}
</script>


<style lang="stylus" rel="stylesheet/stylus">
</style>




// WEBPACK FOOTER //
// src/components/HCS/dailystatics.vue